$(function () {
    var $content = $('#content'),
        $wrapper = $('.used-cars', $content),
        $advancedSearchContainer = $('.advanced-search', $wrapper),
        $sortingElement = $('.result-order', $wrapper),
        $offersContainer = $('.car-list', $wrapper),
        $loadingSpinner = $('[data-global-loading-spinner]', $wrapper),
        $matchCount = $('.match-count-search-result', $wrapper),
        formPagination = new FormPagination($content),
        fadeDuration = 350,
        $brandSelect = $('select[name="brand"]'),
        $modelSelect = $('select[name="model"]');

    $('.range-slider', $wrapper).each(function () {
        new RangeSlider(
            $(this),
            {
                'numberFormat': false
            }
        ).onChanged(onFormSubmit);
    });

    var usedCarStorageCountController = new CarStorageCountController(
        window.usedCarBookmarkList,
        window.usedCarComparisonList
    );

    $('.advanced-search-element', $advancedSearchContainer).find('select, :checkbox').on('change', onFormSubmit);

    $sortingElement.on('change', onFormSubmit);

    formPagination
        .addOnButtonClick(onFormSubmit);

    usedCarStorageCountController
        .setStates()
        .updateStorageCount();

    // initialer Aufruf
    if ($modelSelect.val() !== '') {
        $modelSelect.prop('readonly', false);
    }

    onFormSubmit();

    function onFormSubmit() {
        $loadingSpinner.fadeIn(fadeDuration, function () {
            setCss('hidden');
        });

        var requestUri = $wrapper.data('request-uri'),
            pageNumber = 1,
            sortOrder = '',
            sortType = '',
            $selectedSortOption = $sortingElement.find(':selected'),
            selectedSortOrder = $selectedSortOption.data('sortOrder');

        if (selectedSortOrder !== undefined) {
            sortOrder = selectedSortOrder;
            sortType = $selectedSortOption.val();
        }

        var $pageNumber = $('[name="page"]');

        if ($pageNumber.length > 0) {
            pageNumber = $pageNumber.val();
        }

        var $form = $advancedSearchContainer.find('form');
        var filterData = $form.serializeArray();
        var modelSelected = $modelSelect.data('option-selected');

        if (modelSelected > 0) {
            filterData.push({
                name: 'model',
                value: modelSelected.toString(),
            });
        }

        var requestData = {
            'pageNumber': pageNumber,
            'sortType': sortType,
            'sortOrder': sortOrder,
            'filter': filterData
        };

        const buildUrl = (filterData) => {
            const url = new URL(window.location.href);

            for (let i = 0; i < filterData.length; i++) {
                url.searchParams.set(filterData[i].name, filterData[i].value);
            }

            return url;
        };

        window.history.pushState(null, '', buildUrl(filterData));

        $.getJSON(requestUri, requestData, function (response) {
            if (!response || !response.html) {
                if ('console' in window) {
                    console.error(response);
                }
                throw new Error('Invalid response given: ' + JSON.stringify(response));
            }

            $offersContainer.html(response.html);
            $matchCount.html(response.total);
            usedCarStorageCountController.setStates();

            var $carListPagination = $('.car-list-pagination');
            var $sortingForm = $('.sorting-form');

            if (response.total > 0) {
                $carListPagination.html(response.pagination_html).show();
                $sortingForm.show();
            } else {
                $carListPagination.hide();
                $sortingForm.hide();
            }

            if (response.filter_html !== undefined) {
                $.each(response.filter_html, function (elementId, elementhtml) {
                    $('#' + elementId).html(elementhtml);
                });
            }

            if ($brandSelect.val() === '') {
                $modelSelect.find('option').each((key, element) => {
                    var $element = $(element);

                    if (key === 0) {
                        $element.prop('selected', true);
                        return;
                    }

                    $element.remove();
                })

                $modelSelect.attr('readonly', 'readonly');
            } else {
                $modelSelect.removeAttr('readonly');
            }

            $loadingSpinner.fadeOut(fadeDuration, function () {
                setCss();
            });

            smoothScroll($('.match-count-search-result'));
        });
    }

    function smoothScroll($element) {
        $('html, body').stop().animate({
            scrollTop: $element.offset().top - 150
        }, 700, 'easeInOutExpo');
    }

    function setCss(state) {
        var $bodyContainer = $('body');
        $bodyContainer.css({
            overflow: ''
        });
        if (state === 'hidden') {
            $bodyContainer.css({
                overflow: 'hidden'
            });
        }
        $loadingSpinner.height($(document).height());
    }
});
